import { Text, Flex, useToast, Checkbox } from '@chakra-ui/react';
import Editor from '@monaco-editor/react';
import { FormikProps } from 'formik';
import * as _ from 'lodash';
import React from 'react';

import { CreditAgreement } from '@finley-technologies/finley-types';

import { TAccountGQLType } from '../../../../../../../../types/dashboard-admin-gqlTypes.generated.d';
import { OrganizationMap } from 'packages/creditAgreements/ui/types';

const { sortBy } = _;

type TAccountsSumConfigProps = {
  formProps: FormikProps<CreditAgreement.Config.CommonPostgresQuery.Query.TAccountsSumQuery>;
  tAccounts: TAccountGQLType[];
  organizationMap: OrganizationMap;
};
// !TODO @eldarshamukhamedov Using the TSomething naming convention is confusing; T* is often used
// to denote types (see TAccountGQLType import in this very file)
export const TAccountsSumConfig = ({
  formProps,
  tAccounts,
  organizationMap,
}: TAccountsSumConfigProps) => {
  const toast = useToast();

  const initiallyActiveTAccountsSet = new Set(
    formProps.values.parameterConfig.tAccountDetails.accountDetails.map(
      (account) => `${account.counterpartySlug}-${account.tAccount}`,
    ),
  );

  const mappedTAccounts = sortBy(
    tAccounts.map((tAccount) => {
      const org = organizationMap[tAccount.organizationId];
      if (!org) {
        toast({
          position: 'top',
          status: 'error',
          isClosable: true,
          duration: 5000,
          title: `Organization does not exist for tAccount ${tAccount.tAccount} orgId ${tAccount.organizationId}. This needs to be resolved to continue.`,
        });
        return {
          tAccount: 'ERROR',
          creditFacilityId: 'ERROR',
          counterpartySlug: 'ERROR',
          checked: false,
        };
      }
      return {
        tAccount: tAccount.tAccount,
        counterpartySlug: org.entity.slug,
        creditFacilityId: tAccount.creditFacilityId,
        checked: initiallyActiveTAccountsSet.has(
          `${org.entity.slug}-${tAccount.tAccount}`,
        ),
      };
    }),
    (el) => `${el.counterpartySlug}-${el.tAccount}`,
  );

  return (
    <Flex flexDir="column">
      <Flex mb="3">
        <Text>Starting Date Formula:</Text>
        <Editor
          value={formProps.values.parameterConfig.startDateFormula.formula}
          onChange={(val) =>
            formProps.setFieldValue(
              'parameterConfig.startDateFormula.formula',
              val,
            )
          }
          width="100%"
          theme="vs-dark"
          height="15vh"
        />
      </Flex>
      <Flex mb="3">
        <Text>Ending Date Formula:</Text>
        <Editor
          value={formProps.values.parameterConfig.endDateFormula.formula}
          onChange={(val) =>
            formProps.setFieldValue(
              'parameterConfig.endDateFormula.formula',
              val,
            )
          }
          width="100%"
          theme="vs-dark"
          height="15vh"
        />
      </Flex>
      <Flex mb="3" flexDir="column">
        <Text>T Accounts</Text>
        {mappedTAccounts.map((account, idx) => {
          return (
            <Flex
              key={`portfolio-covenant-postgres-parameter-t-accounts-sum-${account.counterpartySlug}-${account.tAccount}`}
            >
              <Checkbox
                isChecked={account.checked}
                onChange={(e) => {
                  const updatedSelections = mappedTAccounts
                    .map((selection, _idx) => {
                      return _idx === idx
                        ? { ...selection, checked: e.target.checked }
                        : selection;
                    })
                    .filter((selection) => selection.checked)
                    .map((selection) => ({
                      counterpartySlug: selection.counterpartySlug,
                      tAccount: selection.tAccount,
                    }));
                  formProps.setFieldValue(
                    'parameterConfig.tAccountDetails.accountDetails',
                    updatedSelections,
                  );
                }}
              />
              <Text ml="3">
                {account.counterpartySlug} : {account.tAccount}
              </Text>
            </Flex>
          );
        })}
      </Flex>
    </Flex>
  );
};
